export default __webpack_public_path__ + "static/media/kevin5.d77c7f38.png";